module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_overview_04.1f543a2b.svg";